<template>
  <gg-modal :is-active="modal" @close="close">
    <template v-slot:toolbar>
      Install Site Seal
    </template>
    <template v-slot:body>
      <p class="mb-3 pt-2">
        Install your GlobalSign SSL Certificate Secure Site Seal by implementing the below script into your web site.
      </p>
      <textarea
        @click="$event.target.select()"
        class="integration-code"
        readonly
        rows="7"
      >
        <span id="ss_img_wrapper_115-55_image_en">
          <a href="http://www.alphassl.com/ssl-certificates/wildcard-ssl.html" target="_blank" title="SSL Certificates">
            <img alt="Wildcard SSL Certificates" border=0 id="ss_img" src="//seal.alphassl.com/SiteSeal/images/alpha_noscript_115-55_en.gif" title="SSL Certificate">
          </a>
        </span>
        <script type="text/javascript" src="//seal.alphassl.com/SiteSeal/alpha_image_115-55_en.js"></script>
      </textarea>
    </template>
    <template v-slot:actions>
      <gg-btn primary @click="close">Cancel</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
export default {
  name: 'InstallSiteSeal',
  props: {
    modal: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  },
}
</script>

<style scoped>
  .integration-code {
    width: 100%;
    font-family: monospace;
    font-size: 0.8rem;
  }
</style>
